module.exports = __webpack_public_path__ + "static/media/ea1.431fb49f.gif";